export const home = {
  new: 'customerEndpoint/v2/home',
  structure: '_ah/v2/api/home'
};
